var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};
/* Total Columns Width + Total Gaps Width */


export var calculateGridWidth = function calculateGridWidth(columnCount) {
  return "calc((24rem * " + columnCount + ") + (4rem * " + (columnCount - 1) + "))";
};
/* Title width + Total Colums Width + Total Gaps Width + Total Paddings Width */

export var calculateSubmenuWidth = function calculateSubmenuWidth(columnWidth) {
  return "calc(15rem + (4.6rem * 2) + " + calculateGridWidth(columnWidth) + ");";
}; // eslint-disable-line max-len

/* Calcualtes maximum supplied columns to  */

export var getMaxColumns = function getMaxColumns(navLink) {
  var maxColumns = 0;
  navLink.submenuRows.forEach(function (row) {
    maxColumns = row.submenuItems.length > maxColumns ? row.submenuItems.length : maxColumns;
  });
  return maxColumns;
};
export var mergeTwoRefs = function mergeTwoRefs(refA, refB) {
  if (!refA.current && !refB.current) return {
    current: []
  };
  if (!refA.current) return {
    current: refB.current
  };
  if (!refB.current) return {
    current: refA.current
  };
  return {
    current: __spread(refA.current, refB.current)
  };
};